import "./Terms.css";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { END_URL } from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import buttonloader from "../../images/buttonloader.gif";


function Terms({ onsignup }) {
  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [ButtonLoad, setButtonLoad] = useState(false);


  useEffect(() => {
    const fetchAbout = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(`${END_URL}/about`);
        if (Array.isArray(response.data.data) && response.data.data.length > 0) {
          setAbout(response.data.data[0]);
        } else {
          setError("No about data found.");
        }
      } catch (err) {
        console.error("Error fetching about data:", err);
        setError("Failed to fetch about data.");
      } finally {
        setLoading(false);
      }
    };

    fetchAbout();
  }, []);


  const LoginShow = () => {

    window.scrollTo({ top: 0, behavior: 'smooth' });
    onsignup(true);
  };


  if (error)
    return (
      <div className="priv-main container">
        <div className="text-danger">{error}</div>
      </div>
    );

  if (!about) return null;

  const showSignupBackButton = window.location.search.includes("signup");

  return (
    <div className="priv-main">
      <div className="container">
        <div className="row">
          <div className="col-md-12 priv-text-div">
            <div
              className="priv-title"
              dangerouslySetInnerHTML={{ __html: about.termstitle }}
            />
            <div
              className="priv-text"
              dangerouslySetInnerHTML={{ __html: about.termscontent }}
            />

            {showSignupBackButton && (

              // <a className="submit-btn sing-btn" onClick={LoginShow}>
              //    Back to Sign Up 
              // </a>


              <a className="button common term-btn" onClick={LoginShow} >

                <span> Back to Sign Up</span>

                <span>  {!ButtonLoad && <FontAwesomeIcon className="icc" icon={faArrowRight} />}  {ButtonLoad && <img src={buttonloader} alt="Loading" />} </span>

              </a>


            )}

          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
